import type { CoachDigitalTwinRuntime } from "@/lib/behavior/behaviorContracts";

export interface CoachRuntimeSurfaceViewModel {
  badgeLabel: string;
  summary: string;
  detail: string;
}

export function buildCoachRuntimeSurfaceViewModel(
  runtime: CoachDigitalTwinRuntime,
): CoachRuntimeSurfaceViewModel {
  const frameworkCount = runtime.philosophy.lens.frameworks.length;
  const hasPhilosophy = Boolean(runtime.philosophy.lens.philosophy);
  const hasVoice = Boolean(runtime.voice.voiceSummary || runtime.voice.questionStems.length || runtime.voice.phraseBank.length);
  const lensName = runtime.philosophy.lens.lensName || "Custom coach lens";
  const identityStatus = runtime.identity.activation.status;
  const parsedReferences = runtime.identity.ingestionReport.parsedReferenceCount;
  const totalReferences = runtime.identity.ingestionReport.referenceCount;

  if (runtime.status === "configured") {
    const detailParts: string[] = [`Identity ${identityStatus}`];
    if (parsedReferences > 0 || totalReferences > 0) {
      detailParts.push(`${parsedReferences}/${totalReferences} references`);
    }
    if (hasVoice) {
      detailParts.push("Voice ready");
    } else if (hasPhilosophy || frameworkCount > 0) {
      detailParts.push("Lens ready");
    }

    return {
      badgeLabel: "Coach lens active",
      summary: `${lensName} is shaping this coach surface.`,
      detail: detailParts.join(" • "),
    };
  }

  return {
    badgeLabel: "Default coach lens",
    summary: "Coach surfaces are running on the default Veera lens.",
    detail: "Add philosophy or voice guidance to personalize interpretation and delivery.",
  };
}
